import React from 'react';
import { Grid, List, Paper } from '@material-ui/core';
import { TreeItem, TreeView } from '@material-ui/lab';
import { ChevronDownIcon } from '../../../../../core/themes/icons/ChevronDownIcon';
import { ChevronRightIcon } from '../../../../../core/themes/icons/ChevronRightIcon';
import TreeListFilters from './TreeListFilters';
import { filterData, sortList } from './utils';
import TreeTitle from './TreeTitle';
import TreeError from './TreeError';
import NodeRenderer from './NodeRenderer';

const renderTreeItems = ({
  node,
  classes,
  classesCustom,
  handleSelect,
  handleDoubleClick,
  stepReadOnly
}) => {
  const commonProps = {
    key: node.nodeId,
    nodeId: node.nodeId,
    label: (
      <NodeRenderer
        node={node}
        classes={classes}
        handleSelect={handleSelect}
        handleDoubleClick={handleDoubleClick}
        stepReadOnly={stepReadOnly}
      />
    ),
    classes: {
      root: classesCustom.rootTreeItem,
      content:
        node.fundNode && node.fundInvestorTags.length > 0
          ? classesCustom.content
          : classesCustom.contentFF,
      label: classesCustom.label,
      iconContainer: classesCustom.iconContainer
    }
  };

  if (node.fundFamilyNode) {
    return (
      <TreeItem {...commonProps}>
        {node.funds.map(fund =>
          renderTreeItems({
            node: fund,
            classes,
            classesCustom,
            handleSelect,
            handleDoubleClick,
            stepReadOnly
          })
        )}
      </TreeItem>
    );
  } else if (node.fundNode && node.fundInvestorTags.length > 0) {
    return (
      <TreeItem {...commonProps}>
        {node.fundInvestorTags.map(fiTag =>
          renderTreeItems({
            node: fiTag,
            classes,
            classesCustom,
            handleSelect,
            handleDoubleClick,
            stepReadOnly
          })
        )}
      </TreeItem>
    );
  } else {
    return <TreeItem {...commonProps} />;
  }
};

const TreeList = props => {
  const {
    classes,
    classesCustom,
    searchFundNameQuery,
    setSearchFundNameQuery,
    fundTags,
    fundFamilies,
    selectedFundFamily,
    handleFundFamilyChange,
    selectedFundTags,
    onFundTagsChange,
    nodesExpanded,
    nodesSelected,
    handleToggle,
    handleSelect,
    list,
    listTitle,
    listSide,
    data = [],
    handleDoubleClick,
    stepReadOnly,
    formRenderProps
  } = props;

  const listFiltered = sortList(
    list.filter(node =>
      filterData(
        node,
        searchFundNameQuery,
        selectedFundFamily?.id,
        selectedFundTags
      )
    )
  );

  return (
    <Grid item xs={5} className={classes.gridLarge}>
      <TreeTitle
        classes={classes}
        listTitle={listTitle}
        listSide={listSide}
        list={list}
        data={data}
      />
      <TreeListFilters
        classesCustom={classesCustom}
        searchFundNameQuery={searchFundNameQuery}
        setSearchFundNameQuery={setSearchFundNameQuery}
        fundTags={fundTags}
        selectedFundTags={selectedFundTags}
        onFundTagsChange={onFundTagsChange}
        fundFamilies={fundFamilies}
        selectedFundFamily={selectedFundFamily}
        handleFundFamilyChange={handleFundFamilyChange}
        isFundFamilyFilterAvailable={fundFamilies.length > 0}
        isFundTagsFilterAvailable={fundTags.length > 0}
        listSide={listSide}
      />
      <Paper className={classes.paper}>
        <List component="nav" className={classes.list}>
          <TreeView
            classes={{ root: classesCustom.rootTreeView }}
            defaultCollapseIcon={
              <div className={classes.groupChevron}>
                <ChevronDownIcon />
              </div>
            }
            defaultExpandIcon={
              <div className={classes.groupChevron}>
                <ChevronRightIcon />
              </div>
            }
            expanded={nodesExpanded}
            selected={nodesSelected}
            onNodeToggle={handleToggle}
            onNodeSelect={handleSelect}
            multiSelect
          >
            {listFiltered.map(node =>
              renderTreeItems({
                node,
                classes,
                classesCustom,
                handleSelect,
                handleDoubleClick,
                stepReadOnly
              })
            )}
          </TreeView>
        </List>
      </Paper>
      <TreeError listSide={listSide} formRenderProps={formRenderProps} />
    </Grid>
  );
};

export default TreeList;
